// Tag input — one text box holding tag pills. Type, pick a suggestion or add
// a new tag, × inside a pill removes it. No dropdown, no Add button.
// Markup comes from the +tag-input Pug mixin (components/pug/_tag-input.pug);
// styles from css/tag-input.css.
//
// Opt in per app: NOT bundled by components/js/index.js. require() it from
// your own bundle or load it as a plain <script>. Window globals only.
//
// Two modes, chosen by the markup:
//   live  (data-endpoint)  every add/remove POSTs JSON to the endpoint and the
//                          pills are redrawn from the response. Body is one of
//                          { add: <id> } | { name: "<typed name>" } | { remove: <id> };
//                          the server answers { tags: [{ id, name, color }] }
//                          or { error: "..." } with a 4xx.
//   form  (data-name)      pills carry hidden inputs named data-name, so the
//                          tags submit with the surrounding form. An existing
//                          tag submits its id; a new one submits its name.
//
// Fires `tag-input:change` (bubbles) on the root with detail { tags }.
// Everything is delegated from document, so markup inserted later (panels,
// fragments) works without an init call. Elements are found by data-* hooks,
// never by styling classes.
(function () {
  'use strict';
  if (window.TagInput) return;

  var SEL = '[data-tag-input]';
  var seq = 0;

  function rootOf(el) { return el && el.closest ? el.closest(SEL) : null; }
  function field(root) { return root.querySelector('[data-ti-field]'); }
  function menu(root) { return root.querySelector('[data-ti-menu]'); }
  function list(root) { return root.querySelector('[data-ti-pills]'); }
  function note(root) { return root.querySelector('[data-ti-note]'); }
  function norm(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }
  function lower(s) { return norm(s).toLowerCase(); }

  function cfg(root) {
    var d = root.dataset;
    return {
      endpoint: d.endpoint || '',
      name: d.name || '',
      csrf: d.csrf || '',
      allowNew: d.allowNew !== 'false',
      maxWords: parseInt(d.maxWords || '0', 10) || 0,
      maxLength: parseInt(d.maxLength || '0', 10) || 0,
      maxTags: parseInt(d.maxTags || '0', 10) || 0,
      limit: parseInt(d.suggest || '8', 10) || 8,
      newLabel: d.newLabel || 'Add new tag',
      ruleText: d.ruleText || '',
      removeLabel: d.removeLabel || 'Remove'
    };
  }

  // All known tags (the suggestion pool), parsed once and kept on the element.
  function options(root) {
    if (!root._tiOptions) {
      try { root._tiOptions = JSON.parse(root.dataset.options || '[]'); } catch (_e) { root._tiOptions = []; }
    }
    return root._tiOptions;
  }

  function current(root) {
    return Array.prototype.map.call(list(root).querySelectorAll('[data-ti-pill]'), function (li) {
      return { id: li.dataset.id ? Number(li.dataset.id) : null, name: li.dataset.label, color: li.dataset.color || '' };
    });
  }

  function validNew(c, name) {
    if (!name) return false;
    if (c.maxLength && name.length > c.maxLength) return false;
    if (c.maxWords) {
      var words = name.split(' ').filter(function (w) { return !/^(&|and|\/|\+|-)$/i.test(w); });
      if (words.length > c.maxWords) return false;
    }
    return true;
  }

  function say(root, text) {
    var n = note(root);
    if (!n) return;
    n.textContent = text || '';
    n.hidden = !text;
  }

  // ── Pills ────────────────────────────────────────────────────────────────
  function pill(root, tag) {
    var c = cfg(root);
    var li = document.createElement('li');
    li.className = 'tag-input__pill' + (tag.color ? ' tag-input__pill--' + tag.color : '');
    li.setAttribute('data-ti-pill', '');
    if (tag.id != null) li.dataset.id = tag.id;
    li.dataset.label = tag.name;
    if (tag.color) li.dataset.color = tag.color;
    var label = document.createElement('span');
    label.className = 'tag-input__label';
    label.textContent = tag.name;
    li.appendChild(label);
    if (c.name) {
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = c.name;
      h.value = tag.id != null ? tag.id : tag.name;
      li.appendChild(h);
    }
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'tag-input__x';
    x.setAttribute('data-ti-remove', '');
    x.setAttribute('aria-label', c.removeLabel + ' ' + tag.name);
    x.textContent = '×';
    li.appendChild(x);
    return li;
  }

  function redraw(root, tags) {
    var ul = list(root);
    Array.prototype.forEach.call(ul.querySelectorAll('[data-ti-pill]'), function (li) { li.remove(); });
    var anchor = ul.querySelector('[data-ti-entry]');
    tags.forEach(function (t) { ul.insertBefore(pill(root, t), anchor); });
    // Tags the server created join the suggestion pool.
    var pool = options(root);
    tags.forEach(function (t) {
      if (!pool.some(function (o) { return (t.id != null && o.id === t.id) || lower(o.name) === lower(t.name); })) pool.push(t);
    });
    root.classList.toggle('tag-input--empty', !tags.length);
    root.dispatchEvent(new CustomEvent('tag-input:change', { bubbles: true, detail: { tags: tags } }));
  }

  // ── Server ───────────────────────────────────────────────────────────────
  function send(root, body) {
    var c = cfg(root);
    var f = field(root);
    root.setAttribute('aria-busy', 'true');
    if (f) f.disabled = true;
    return fetch(c.endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json', accept: 'application/json', 'x-csrf-token': c.csrf },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return { error: 'HTTP ' + r.status }; }).then(function (d) {
        if (!r.ok || d.ok === false || d.error) throw new Error(d.error || ('HTTP ' + r.status));
        return d;
      });
    }).then(function (d) {
      redraw(root, d.tags || []);
      say(root, '');
    }).catch(function (err) {
      say(root, err.message || 'That did not save');
    }).then(function () {
      root.removeAttribute('aria-busy');
      if (f) { f.disabled = false; f.focus(); }
    });
  }

  function add(root, item) {
    var c = cfg(root);
    var have = current(root);
    if (have.some(function (t) { return (item.id != null && t.id === item.id) || lower(t.name) === lower(item.name); })) {
      say(root, 'Already added');
      return;
    }
    if (c.maxTags && have.length >= c.maxTags) { say(root, 'At most ' + c.maxTags + ' tags'); return; }
    field(root).value = '';
    close(root);
    if (c.endpoint) return send(root, item.id != null ? { add: item.id } : { name: item.name });
    redraw(root, have.concat([item]));
  }

  function remove(root, li) {
    if (!li) return;
    var id = li.dataset.id ? Number(li.dataset.id) : null;
    var c = cfg(root);
    if (c.endpoint && id != null) return send(root, { remove: id });
    redraw(root, current(root).filter(function (t) { return !(t.id === id && t.name === li.dataset.label); }));
    var f = field(root);
    if (f) f.focus();
  }

  // ── Suggestions ──────────────────────────────────────────────────────────
  function suggestions(root) {
    var c = cfg(root);
    var q = norm(field(root).value);
    var ql = q.toLowerCase();
    var have = current(root);
    var taken = function (o) { return have.some(function (t) { return (o.id != null && t.id === o.id) || lower(t.name) === lower(o.name); }); };
    var pool = options(root).filter(function (o) { return !taken(o); });
    var hits = pool.filter(function (o) { return !ql || lower(o.name).indexOf(ql) >= 0; });
    hits.sort(function (a, b) {
      var as = lower(a.name).indexOf(ql) === 0 ? 0 : 1;
      var bs = lower(b.name).indexOf(ql) === 0 ? 0 : 1;
      return as - bs || (b.count || 0) - (a.count || 0) || a.name.localeCompare(b.name);
    });
    var out = hits.slice(0, c.limit).map(function (o) { return { kind: 'tag', tag: o }; });
    var exact = options(root).concat(have).some(function (o) { return lower(o.name) === ql; });
    if (q && !exact && c.allowNew) {
      if (validNew(c, q)) out.push({ kind: 'new', tag: { id: null, name: q } });
      else if (c.ruleText) out.push({ kind: 'rule', text: c.ruleText });
    }
    if (q && have.some(function (t) { return lower(t.name) === ql; })) out.push({ kind: 'rule', text: 'Already added' });
    return out;
  }

  function open(root) {
    var m = menu(root);
    var f = field(root);
    var items = suggestions(root);
    m.innerHTML = '';
    root._tiItems = items;
    items.forEach(function (it, i) {
      var li = document.createElement('li');
      li.id = m.id + '-' + i;
      if (it.kind === 'rule') {
        li.className = 'tag-input__option tag-input__option--rule';
        li.setAttribute('aria-disabled', 'true');
        li.textContent = it.text;
      } else {
        li.className = 'tag-input__option' + (it.kind === 'new' ? ' tag-input__option--new' : '');
        li.setAttribute('role', 'option');
        li.setAttribute('data-ti-option', String(i));
        if (it.kind === 'new') {
          li.appendChild(document.createTextNode(cfg(root).newLabel + ' '));
          var b = document.createElement('strong');
          b.textContent = '“' + it.tag.name + '”';
          li.appendChild(b);
        } else {
          var sw = document.createElement('span');
          sw.className = 'tag-input__swatch' + (it.tag.color ? ' tag-input__pill--' + it.tag.color : '');
          sw.setAttribute('aria-hidden', 'true');
          li.appendChild(sw);
          li.appendChild(document.createTextNode(it.tag.name));
          if (it.tag.count != null) {
            var n = document.createElement('span');
            n.className = 'tag-input__count';
            n.textContent = it.tag.count;
            li.appendChild(n);
          }
        }
      }
      m.appendChild(li);
    });
    var any = items.length > 0;
    m.hidden = !any;
    f.setAttribute('aria-expanded', any ? 'true' : 'false');
    // Typing highlights the best match so Enter takes it.
    var first = items.findIndex(function (it) { return it.kind !== 'rule'; });
    activate(root, norm(f.value) && first >= 0 ? first : -1);
  }

  function close(root) {
    var m = menu(root);
    var f = field(root);
    if (m) { m.hidden = true; m.innerHTML = ''; }
    if (f) { f.setAttribute('aria-expanded', 'false'); f.removeAttribute('aria-activedescendant'); }
    root._tiItems = [];
    root._tiActive = -1;
  }

  function activate(root, i) {
    var m = menu(root);
    var f = field(root);
    root._tiActive = i;
    Array.prototype.forEach.call(m.querySelectorAll('[data-ti-option]'), function (li) {
      var on = Number(li.getAttribute('data-ti-option')) === i;
      li.classList.toggle('is-active', on);
      li.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) { f.setAttribute('aria-activedescendant', li.id); li.scrollIntoView({ block: 'nearest' }); }
    });
    if (i < 0) f.removeAttribute('aria-activedescendant');
  }

  function move(root, step) {
    var items = root._tiItems || [];
    var picks = items.map(function (it, i) { return it.kind === 'rule' ? -1 : i; }).filter(function (i) { return i >= 0; });
    if (!picks.length) return;
    var at = picks.indexOf(root._tiActive);
    var next = at < 0 ? (step > 0 ? 0 : picks.length - 1) : (at + step + picks.length) % picks.length;
    activate(root, picks[next]);
  }

  function commit(root) {
    var items = root._tiItems || [];
    var it = items[root._tiActive];
    if (it && it.kind !== 'rule') return add(root, it.tag), true;
    var q = norm(field(root).value);
    if (!q) return false;
    var ql = q.toLowerCase();
    var known = options(root).find(function (o) { return lower(o.name) === ql; });
    if (known) return add(root, known), true;
    var c = cfg(root);
    if (c.allowNew && validNew(c, q)) return add(root, { id: null, name: q }), true;
    say(root, c.ruleText || 'Pick a tag from the list');
    return true;
  }

  // ── Wiring (delegated) ───────────────────────────────────────────────────
  function prime(root) {
    if (root._tiReady) return;
    root._tiReady = true;
    var f = field(root);
    var m = menu(root);
    if (!m.id) m.id = 'ti-menu-' + (++seq);
    f.setAttribute('aria-controls', m.id);
    f.removeAttribute('list'); // the no-JS <datalist> fallback would double up
  }

  document.addEventListener('focusin', function (e) {
    if (!e.target.matches || !e.target.matches('[data-ti-field]')) return;
    var root = rootOf(e.target);
    prime(root);
    open(root);
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-ti-field]')) return;
    var root = rootOf(e.target);
    prime(root);
    say(root, '');
    open(root);
  });

  document.addEventListener('keydown', function (e) {
    if (!e.target.matches || !e.target.matches('[data-ti-field]')) return;
    var root = rootOf(e.target);
    prime(root);
    var f = e.target;
    var shown = !menu(root).hidden;
    if (e.key === 'ArrowDown') { e.preventDefault(); if (!shown) open(root); move(root, 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); if (!shown) open(root); move(root, -1); }
    else if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); commit(root); }
    else if (e.key === 'Tab' && shown && root._tiActive >= 0 && norm(f.value)) { e.preventDefault(); commit(root); }
    else if (e.key === 'Escape') { if (shown) { e.preventDefault(); close(root); } }
    // Backspace in an empty field deliberately removes nothing: holding it
    // down would strip every tag. Removing is the × inside a pill.
  });

  // mousedown so the field keeps focus while an option is picked.
  document.addEventListener('mousedown', function (e) {
    var opt = e.target.closest && e.target.closest('[data-ti-option]');
    if (!opt) return;
    var root = rootOf(opt);
    if (!root) return;
    e.preventDefault();
    var it = (root._tiItems || [])[Number(opt.getAttribute('data-ti-option'))];
    if (it && it.kind !== 'rule') add(root, it.tag);
  });

  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-ti-remove]');
    if (x && rootOf(x)) {
      e.preventDefault(); // the no-JS fallback wraps × in a form
      remove(rootOf(x), x.closest('[data-ti-pill]'));
      return;
    }
    // A click on the box (not a pill or option) focuses the field.
    var root = rootOf(e.target);
    if (root && !e.target.closest('[data-ti-pill], [data-ti-menu], a, button, input')) {
      var f = field(root);
      if (f) f.focus();
    }
  });

  // The no-JS fallback's text form: with JS, Enter is handled above.
  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('[data-ti-form]')) e.preventDefault();
  }, true);

  document.addEventListener('focusout', function (e) {
    if (!e.target.matches || !e.target.matches('[data-ti-field]')) return;
    var root = rootOf(e.target);
    setTimeout(function () { if (!root.contains(document.activeElement)) close(root); }, 120);
  });

  window.TagInput = { refresh: function (root, tags) { redraw(root, tags); } };
})();
